import { render, staticRenderFns } from "./BindAll.vue?vue&type=template&id=c8a106a0&lang=pug&"
import script from "./BindAll.vue?vue&type=script&lang=ts&"
export * from "./BindAll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports